
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Gastric_neuroendocrine_tumor",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Gastric_neuroendocrine_tumor.vue